(function () {
  let registry = window.__vxiRegistry || (window.__vxiRegistry = []);

  function unregister(root) {
    for (let i = registry.length - 1; i >= 0; i--) {
      if (registry[i].root === root) {
        if (registry[i].destroy) registry[i].destroy();
        registry.splice(i, 1);
      }
    }
  }

  function init(root) {
    if (!root || root.dataset.vxiInit) return;
    root.dataset.vxiInit = '1';

    let stage = root.querySelector('[data-vxi-stage]');
    let word = root.querySelector('[data-vxi-word]');
    if (!stage || !word) return;

    let reduceMotion = false;
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {}

    let started = false;
    let finished = false;
    let tl = null;
    let trigger = null;
    let pivotIdx = 0;
    let resizeTimer = 0;
    let gsapRef = null;

    function letterEls() {
      return Array.prototype.slice.call(word.querySelectorAll('[data-vxi-letter]'));
    }

    function nonTmEls(els) {
      return els.filter(function (el) {
        return !el.hasAttribute('data-vxi-tm');
      });
    }

    function tmEl(els) {
      for (let i = 0; i < els.length; i++) {
        if (els[i].hasAttribute('data-vxi-tm')) return els[i];
      }
      return null;
    }

    function setStatic() {
      root.classList.add('is-static');
      if (gsapRef) {
        gsapRef.set(letterEls().concat([word]), { clearProps: 'transform,opacity,x,y' });
      }
      if (tl) {
        tl.kill();
        tl = null;
      }
      if (trigger) {
        trigger.kill();
        trigger = null;
      }
    }

    if (reduceMotion) {
      setStatic();
      return;
    }

    function waitForImages() {
      let imgs = word.querySelectorAll('img');
      let pending = [];
      for (let i = 0; i < imgs.length; i++) {
        (function (img) {
          if (!img.complete) {
            pending.push(
              new Promise(function (resolve) {
                img.addEventListener('load', resolve, { once: true });
                img.addEventListener('error', resolve, { once: true });
              })
            );
          }
        })(imgs[i]);
      }
      return Promise.all(pending);
    }

    function applyStartState(gsap) {
      let els = letterEls();
      let letters = nonTmEls(els);
      let tm = tmEl(els);
      if (!letters.length) return null;

      pivotIdx = Math.floor((letters.length - 1) / 2);
      let pivot = letters[pivotIdx];

      gsap.set(els, { clearProps: 'transform,opacity,x,y' });
      gsap.set(word, { clearProps: 'transform,x' });

      let pivotRect = pivot.getBoundingClientRect();
      let wordShift = window.innerWidth / 2 - (pivotRect.left + pivotRect.width / 2);
      gsap.set(word, { x: wordShift });

      let pivotCenter = (function () {
        let r = pivot.getBoundingClientRect();
        return r.left + r.width / 2;
      })();

      let offsets = [];
      let j;
      for (j = 0; j < letters.length; j++) {
        let lr = letters[j].getBoundingClientRect();
        offsets.push(lr.left + lr.width / 2 - pivotCenter);
      }

      let tmOffset = 0;
      if (tm) {
        let tr = tm.getBoundingClientRect();
        tmOffset = tr.left + tr.width / 2 - pivotCenter;
      }

      for (j = 0; j < letters.length; j++) {
        if (j === pivotIdx) {
          gsap.set(letters[j], { x: 0, y: 500, opacity: 0 });
        } else {
          gsap.set(letters[j], { x: -offsets[j], y: 0, opacity: 0 });
        }
      }

      if (tm) {
        gsap.set(tm, { x: -tmOffset, y: -200, opacity: 0 });
      }

      return { letters: letters, tm: tm, pivot: pivot };
    }

    function recenterWord(gsap) {
      let letters = nonTmEls(letterEls());
      if (!letters.length) return;
      let pivot = letters[Math.min(pivotIdx, letters.length - 1)];
      gsap.set(word, { clearProps: 'transform,x' });
      let r = pivot.getBoundingClientRect();
      gsap.set(word, { x: window.innerWidth / 2 - (r.left + r.width / 2) });
    }

    function buildTimeline(gsap, state) {
      if (tl) {
        tl.kill();
        tl = null;
      }

      tl = gsap.timeline({
        paused: true,
        defaults: { ease: 'power4.out' },
        onStart: function () {
          started = true;
        },
        onComplete: function () {
          finished = true;
        }
      });

      tl.to(state.pivot, { y: 0, opacity: 1, duration: 2.2, ease: 'power3.out' });

      let maxDist = 0;
      let j;
      for (j = 0; j < state.letters.length; j++) {
        let d0 = Math.abs(j - pivotIdx);
        if (d0 > maxDist) maxDist = d0;
      }

      for (let d = 1; d <= maxDist; d++) {
        let ring = [];
        for (j = 0; j < state.letters.length; j++) {
          if (Math.abs(j - pivotIdx) === d) ring.push(state.letters[j]);
        }
        if (!ring.length) continue;
        tl.to(ring, { x: 0, opacity: 1, duration: 1.2 }, d === 1 ? '>' : '-=0.5');
      }

      if (state.tm) {
        tl.to(state.tm, { x: 0, y: 0, opacity: 1, duration: 1.2 }, '-=0.5');
      }
    }

    function bindTrigger() {
      if (trigger) {
        trigger.kill();
        trigger = null;
      }

      if (window.Shopify && Shopify.designMode) {
        tl.play(0);
        return;
      }

      trigger = ScrollTrigger.create({
        trigger: stage,
        start: 'top 70%',
        once: true,
        onEnter: function () {
          if (tl && !started) tl.play(0);
        }
      });
    }

    function rebuild(gsap) {
      let state = applyStartState(gsap);
      if (!state) {
        setStatic();
        return;
      }
      started = false;
      finished = false;
      buildTimeline(gsap, state);
      bindTrigger();
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    }

    function handleResize() {
      if (!gsapRef) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (!started) {
          rebuild(gsapRef);
        } else if (finished) {
          recenterWord(gsapRef);
          if (window.ScrollTrigger) ScrollTrigger.refresh();
        } else if (window.ScrollTrigger) {
          ScrollTrigger.refresh();
        }
      }, 150);
    }

    function handleLoad() {
      if (!gsapRef) return;
      if (!started) rebuild(gsapRef);
      else if (finished) {
        recenterWord(gsapRef);
        if (window.ScrollTrigger) ScrollTrigger.refresh();
      } else if (window.ScrollTrigger) {
        ScrollTrigger.refresh();
      }
    }

    function destroy() {
      window.clearTimeout(resizeTimer);
      if (tl) {
        tl.kill();
        tl = null;
      }
      if (trigger) {
        trigger.kill();
        trigger = null;
      }
    }

    unregister(root);
    registry.push({ root: root, resize: handleResize, load: handleLoad, destroy: destroy });

    let gsapLoader = window.__vxGsapReady;
    if (!gsapLoader) {
      setStatic();
      return;
    }

    gsapLoader()
      .then(function (gsap) {
        if (!gsap || !window.ScrollTrigger) {
          setStatic();
          return;
        }
        gsapRef = gsap;
        return waitForImages().then(function () {
          rebuild(gsap);
        });
      })
      .catch(function () {
        setStatic();
      });
  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vxi]');
    for (let i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (!window.__vxiListenersBound) {
    window.__vxiListenersBound = true;
    window.addEventListener(
      'resize',
      function () {
        for (let i = 0; i < registry.length; i++) {
          if (registry[i].resize) registry[i].resize();
        }
      },
      { passive: true }
    );
    window.addEventListener('load', function () {
      for (let i = 0; i < registry.length; i++) {
        if (registry[i].load) registry[i].load();
      }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      let scope = event.target;
      if (!scope) return;
      let el =
        scope.matches && scope.matches('[data-vxi]')
          ? scope
          : scope.querySelector && scope.querySelector('[data-vxi]');
      if (el) unregister(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    let section = event.target;
    if (!section || !section.querySelector) return;
    let root = section.querySelector('[data-vxi]');
    if (!root) return;
    unregister(root);
    delete root.dataset.vxiInit;
    init(root);
  });
})();
